<template>
  <section class="va-home-section va-quick">
    <vetalfa-home-section-header
      title="Acesso rápido"
      :action-text="showAllAction ? 'Todas as seções' : null"
      @action="$emit('open-all-sections')"
    ></vetalfa-home-section-header>
    <div class="va-home-grid va-quick-grid" :style="gridStyle">
      <vetalfa-section-tile
        v-for="section in visibleSections"
        :key="`home-quick-${section.id || section.name}`"
        :section="section"
        :show-pro="!isPremium && !!section.pro"
        :wide="!!section.highlighted"
        :span="3"
        :banner="mobile"
        :illustration="section.highlighted ? MEDICINES_ART : null"
        @select="$emit('select', section)"
      ></vetalfa-section-tile>
    </div>
  </section>
</template>

<style>
.va-quick {
  gap: 14px;
}

.va-quick-grid {
  gap: 12px;
}
</style>

<script>
import imagesConstants from "@/constants/images.js";
import SectionTile from "@/components/home/SectionTile.vue";
import HomeSectionHeader from "@/components/home/HomeSectionHeader.vue";

/** Ilustracao do bloco de Medicamentos e vacinas. Passa pelo webpack para
    ganhar hash no nome e nunca ficar presa em cache antigo do navegador. */
const MEDICINES_ART = imagesConstants.HOME_MEDICINES;

export default {
  name: "HomeQuickAccess",
  components: {
    "vetalfa-section-tile": SectionTile,
    "vetalfa-home-section-header": HomeSectionHeader,
  },
  props: {
    /** Atalhos vindos do catálogo, já ordenados por `homeOrder`. */
    sections: {
      type: Array,
      default: () => [],
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    isPremium: {
      type: Boolean,
      default: false,
    },
    /** Mobile: alguns atalhos e o botao para o painel. Desktop: a lista toda, sem botao. */
    showAllAction: {
      type: Boolean,
      default: true,
    },
    /** Quantos atalhos mostrar quando ha botao para o painel. */
    limit: {
      type: Number,
      default: 8,
    },
  },
  data() {
    return {
      MEDICINES_ART,
    };
  },
  computed: {
    /**
     * Mobile: o banner de Medicamentos ocupa tres colunas, o proximo atalho
     * fica ao lado e os seguintes formam a segunda linha. Desktop: a lista
     * inteira.
     */
    visibleSections() {
      return this.showAllAction ? this.sections.slice(0, this.limit) : this.sections;
    },
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.mobile ? 4 : 8}, minmax(0, 1fr))`,
        gap: this.mobile ? "12px" : "16px",
        alignItems: "center",
      };
    },
  },
};
</script>
